<template>
  <div class="collection-content-blocks critical-component-clear" />
</template>

<script>
/**
 * Vue: Collection content blocks (collection-content-blocks)
 * -----------------------------------------------------------------------------
 * Adds content block in grid of collections and search.
 * - Static section.
 *
 * @param {Array} blocks - Blocks data.
 *
 */

export default {
  name: 'CollectionContentBlocks',

  props: {
    blocks: {
      type: Array,
      default: () => ([]),
    },
  },

  updated() {
    window.cnvs.contentBlocks = [...this.blocks]
  },
}
</script>

<style lang="scss">
@import './collection-content-blocks';
</style>
